import React from 'react'

const ComponentToPrint = () => {
  return (
    <div>ComponentToPrint
        <img src="https://api.shipengine.com/v1/downloads/10/gJdXDyJCEkSeJ6coiJVxuQ/label-363851913.png"/>
    </div>
  )
}

export default ComponentToPrint